import styled from 'styled-components';

export default styled.img`
  margin-bottom: 24px;
  width: 260px;
`;
